import { useId } from 'react';
import { isUuid } from '@/lib/uuid';

export interface UuidFilterInputProps {
  label: string;
  value: string;
  placeholder: string;
  className: string;
  onChange: (value: string) => void;
}

export function UuidFilterInput({
  label,
  value,
  placeholder,
  className,
  onChange,
}: UuidFilterInputProps) {
  const inputId = useId();
  const errorId = `${inputId}-error`;
  const isInvalid = value !== '' && !isUuid(value);

  return (
    <div className={className}>
      <label htmlFor={inputId}>{label}</label>
      <input
        id={inputId}
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value.trim())}
        placeholder={placeholder}
        aria-invalid={isInvalid || undefined}
        aria-describedby={isInvalid ? errorId : undefined}
        className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
      />
      {isInvalid ? (
        <span id={errorId} className="text-small font-normal text-red-700">
          Enter a full UUID to apply this filter.
        </span>
      ) : null}
    </div>
  );
}
